export default __webpack_public_path__ + "images/b4705180b32e44cdbbb43c621fb90a55-EE_SlideDeckBOOK1024_13.png";